"use client"
import { Button } from "@mui/material"
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles"
import BreadCrumbsWrapper from "common/BreadCrumbs"
import { Desktop, Mobile, useIsDesktop } from "common/MediaQueries"
import useShopUrl from "common/bit/hooks/useShopUrl"
import { useLayoutContext } from "layout/oldLayout/LayoutContext"
import { useEffect, useState } from "react"
import { useHistory, useLocation } from "react-router-dom"
import routes from "routes"
import { useAppDispatch, useTypedSelector } from "store"
import styled, { css } from "styled-components"
import shopTheme from "theme/shopTheme"
import Sidebar from "./Sidebar"
import StepPage from "./StepPage"
import {
  CONTINUE_PURCHASE_LINK,
  MODEL_NAME,
  STEPS_EN,
  STEPS_NAV_DESKTOP_HEIGHT,
} from "./constants"
import Steps from "./stepsNav/Steps"
import {
  fetchAdvancePaymentAmount,
  initSelectedComponentsFromParams,
  setIsDesktop,
} from "./wizardSlice"

const StyledContentWrap = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 0;

  ${(p) => p.theme.breakpoints.up("md")} {
    flex-direction: row;
    align-items: stretch;
    position: relative;
  }
`
const StyledButton = styled(Button)`
  width: 116px;
  height: 32px;
  font-size: 16px;
  border-radius: 3px;
  border: 2px solid ${(p) => p.theme.colors.black};

  z-index: 1;
  background-color: ${(p) => p.theme.colors.lightGrey};
  position: absolute;
  top: 10px;
  left: 10px;
`
const StyledMainContent = styled.div<{
  $page?: string
  $isShowRoomsScreens?: boolean
}>`
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  background-color: ${(p) => p.theme.colors.lightGrey};

  ${(p) => p.theme.breakpoints.up("md")} {
    flex-grow: 1;
    width: 0;
    padding-top: ${STEPS_NAV_DESKTOP_HEIGHT}px;
    ${(p) =>
      p.$isShowRoomsScreens &&
      p.$page !== STEPS_EN.summary &&
      css`
        padding-top: 0;
      `}
  }
`

const Wizard = () => {
  const { model } = useTypedSelector((state) => state.wizard)
  const { initialized } = useTypedSelector((state) => state.auth)
  const isDesktop = useIsDesktop()
  const dispatch = useAppDispatch()
  const shopUrl = useShopUrl(model?.id ?? 0)
  const { pathname } = useLocation()
  const { isShowRoomsScreens } = useLayoutContext()
  const history = useHistory()
  const [isClientSide, setIsClientSide] = useState(false)

  const goBackToStart = () => {
    history.push(routes.detailing.path)
  }
  useEffect(() => {
    if (!shopUrl || !model) return
    localStorage.setItem(CONTINUE_PURCHASE_LINK, shopUrl)
    localStorage.setItem(MODEL_NAME, model?.name)
  }, [shopUrl, model])

  useEffect(() => {
    if (!model || !initialized) return

    dispatch(initSelectedComponentsFromParams(model.id.toString()))
    dispatch(fetchAdvancePaymentAmount())
  }, [dispatch, model, initialized])

  useEffect(() => {
    dispatch(setIsDesktop(isDesktop))
  }, [isDesktop, dispatch])

  useEffect(() => {
    setIsClientSide(true)
  }, [])

  if (!isClientSide) return null

  return (
    <>
      <MuiThemeProvider theme={shopTheme}>
        <StyledContentWrap>
          <Desktop>
            <Sidebar />
          </Desktop>

          <StyledMainContent
            $page={pathname}
            $isShowRoomsScreens={isShowRoomsScreens}
          >
            {pathname !== STEPS_EN.order &&
              isDesktop &&
              !isShowRoomsScreens && (
                <BreadCrumbsWrapper
                  modelName={model?.name}
                  id={model?.id}
                  page="configurator"
                />
              )}
            {isShowRoomsScreens && pathname !== STEPS_EN.detailing && (
              <StyledButton onClick={goBackToStart}>חזרה להתחלה</StyledButton>
            )}
            {pathname !== STEPS_EN.order && (
              <Mobile>
                <Steps />
              </Mobile>
            )}

            <StepPage />
          </StyledMainContent>
        </StyledContentWrap>
      </MuiThemeProvider>
      {/* <OnlineBenefits /> */}
    </>
  )
}

export default Wizard
